import { useZebraPrinter } from "./useZebraPrinter";

export default useZebraPrinter;
